import type { ButtonSizes } from '@archipro-design/aria';
import { Flex, Button } from '@archipro-design/aria';
import { HeartFill, HeartLine } from '@archipro-design/icons';
import SaveToDesignBoard from '~/modules/design-board/component/SaveToDesignBoard';
import type { FavouriteItem } from '~/modules/design-board/type';
import { useIsDisabledInPreview } from '~/modules/root/hook/use-is-disabled-in-preview';
import { useHandleFollow } from '~/modules-rocco/design-board/hook/use-handle-follow';

export const SaveToDesignBoardDiv = ({
    className,
    favouriteItem,
    buttonSize,
}: {
    className: string;
    favouriteItem: FavouriteItem;
    buttonSize: ButtonSizes;
}) => {
    const disableSaveToDesignBoard =
        useIsDisabledInPreview('save_design_board');
    const { isInDesignBoard } = useHandleFollow();
    const isFavourited = isInDesignBoard(favouriteItem.itemId, 'ArticlePin');
    return (
        <Flex className={className}>
            <SaveToDesignBoard
                {...favouriteItem}
                disable={disableSaveToDesignBoard}
            >
                <Button
                    color="dark"
                    size={buttonSize}
                    disabled={disableSaveToDesignBoard}
                    variant={'contained'}
                    transparent={true}
                    iconBefore={
                        isFavourited ? (
                            <HeartFill size="1x" />
                        ) : (
                            <HeartLine size="1x" />
                        )
                    }
                    variables={{
                        darkNoBKGButtonBackgroundColorHover: 'transparent',
                        buttonPadding: 0,
                    }}
                >
                    {`Save${isFavourited ? 'd' : ''} Article`}
                </Button>
            </SaveToDesignBoard>
        </Flex>
    );
};
